function readEnvUrl(key) {
    const raw = process.env[key];
    if (!raw) return null;

    const trimmed = String(raw).trim().replace(/^["']|["']$/g, "");
    return trimmed || null;
}

export const TERMS_URL = readEnvUrl("REACT_APP_TERMS_URL");
export const PRIVACY_URL = readEnvUrl("REACT_APP_PRIVACY_URL");
